import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PdfService {

  constructor(private http: HttpClient) { }

  private apiUrl = `${environment.apiUrl}`;
  private url: string = this.apiUrl + 'api/pdf'; 

  printOffer(offerId: number): Observable<Blob> {
    return this.http.get(`${this.url}/printOffer/${offerId}`, {
      responseType: 'blob'
    });
  }

  printLettersForEmployee(employeeId: number, letter: string): Observable<Blob> {
    return this.http.get(`${this.url}/printLettersForEmployee/${employeeId}/${letter}`, {
      responseType: 'blob'
    });
  }
  
  
}

